import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  setLocale: `${NAMESPACE}_SET_LOCALE`,
  fetchResourcesByKey: `${NAMESPACE}_FETCH_RESOURCES_BY_KEY`,
  fetchResourcesByKeySuccess: `${NAMESPACE}_FETCH_RESOURCES_BY_KEY_SUCCESS`,
};

export const actionCreators = {
  setLocale: payload => ({ type: actions.setLocale, payload }),
  fetchResourcesByKey: payload => ({ type: actions.fetchResourcesByKey, payload }),
  fetchResourcesByKeySuccess: payload => ({ type: actions.fetchResourcesByKeySuccess, payload }),
};

export default {
  actions,
  actionCreators,
};
